import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async fcsApplicationList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-list.fcs_application_list'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async getApplications({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-list.get_applications'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async toggleCreditStatus({ commit }, payload) {
    return await apiService.post(route('member.fcs.application-list.toggle_credit_status'), payload)
  },

  async delete({ commit }, payload) {
    return await apiService.post(route('member.fcs.application-list.delete', payload))
  },

  async fcsApplicationCandidateList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-list.fcs_application_candidate_list'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },

  // 変更時はapiService.jsも要変更
  async downloadApplicationForm({}, payload) {
    const response = await apiService.downloadApplicationForm(route('member.fcs.application-list.download'), payload)
    if (response.status && response.status === 200) {
      return response
    } else if (response.data) {
      return { errors: response.data }
    } else {
      return { errors: 'Unknown' }
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
